import React from "react"
import { Box, Typography } from "@material-ui/core/"

const ChangePaymentText = () => {
  return (
    <Box>
      <Typography style={{ marginBottom: "20px" }}>
        You can change your payment method here:
      </Typography>
    </Box>
  )
}

export default ChangePaymentText
